module.exports = __webpack_public_path__ + "img/logo.f062c8e4.jpeg";